import user from './user';
import app from './app';
import { combineReducers } from 'redux'; //eslint-disable-line
export default combineReducers({
  user,
  app,
});
